import React, { useState } from 'react';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { closeEditVehicle } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import EditVehicle from './EditVehicle';
import Registrations from './Registrations';
import Towing from './Towing';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Attachments from 'components/Attachments';
import Bulletins from './Bulletins';
import { getFullPermissions } from 'reducers/PermissionsReducer';

const useStyles = makeStyles((theme) => ({
  content: {
    margin: -theme.spacing(3),
  },
}));

function EditVehicleDialog(props) {
  const classes = useStyles();
  const { vehicleData } = props;
  const { ptsVehicleID } = vehicleData;
  const firstTab = props.editVehicleContext?.isTowed ? 'towing' : 'edit';
  const [tab, setTab] = useState(firstTab);
  const vehiclePerms = getFullPermissions('globals', 'Vehicles', 'any');

  const close = () => {
    props.closeEditVehicle();
  };

  const renderActions = () => {
    return (
      <>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  const getTitle = () => {
    const title = 'Edit Vehicle';
    return  vehiclePerms.Edit ? (
      `${title}`
    ) : (
      <div className="d-flex" style={{ width: '100%', justifyContent: 'left', textAlign: 'left' }}>
        <span style={{ flex: 0.5 }}>{}</span>
        <span style={{ flex: 0.5, color: 'red', fontWeight: 'bold', fontSize: '21px' }}>
          VIEW ONLY MODE
        </span>
      </div>
    );
  };

  return (
    <Dialog toolbar onClose={close} title={getTitle()} actions={renderActions()} fullScreen>
      <div className={classes.content}>
        <Paper square>
          <Tabs value={tab} onChange={(ev, val) => setTab(val)}>
            <Tab label="Edit Vehicle" value="edit" />
            <Tab label="Registrations" value="registrations" />
            <Tab label="Towing" value="towing" />
            <Tab label="Attachments" value="attachments" />
            <Tab label="Bulletins" value="bulletins" />
          </Tabs>
        </Paper>
        {tab === 'edit' && <EditVehicle ptsVehicleID={ptsVehicleID} vehiclePerms ={vehiclePerms} />}
        {tab === 'registrations' && <Registrations ptsVehicleID={ptsVehicleID} vehiclePerms ={vehiclePerms} />}
        {tab === 'towing' && <Towing ptsVehicleID={ptsVehicleID}  vehiclePerms ={vehiclePerms} />}
        {tab === 'attachments' && <Attachments type="Vehicle" id={ptsVehicleID} permissions ={vehiclePerms} />}
        {tab === 'bulletins' && <Bulletins vehicle={vehicleData} vehiclePerms ={vehiclePerms} />}
      </div>
    </Dialog>
  );
}

export default connect(null, { closeEditVehicle })(EditVehicleDialog);
